<template>
  <div class="content">
    <div class="content__left">
      <div class="left__title">
        <p>{{sedRouteTitle[$route.params.name]}}</p>
      </div>
      <div class="left__main" v-show="tabindex===0">
        <a v-for="(item, key, index) in content.left" :key="index" :class="key" @click="linkM">{{item}}</a>
      </div>
    </div>
    <div class="content__right">
      <div class="right__title">
        <span :class="{'active': tabindex===0}" @click="changeTab(0)">API</span>
        <span :class="{'active': tabindex===1}" @click="changeTab(1)">正在使用</span>
      </div>
      <div class="hrsty"></div>
      <div class="right__main">
        <div class="logolist" v-show="tabindex===1">
          <component-customer-logo class="logo" v-for="(item, index) in listData" :key="index" :imgdata="item"></component-customer-logo>
        </div>
        <div class="apicontent" v-show="tabindex===0">
          <div v-for="(item, key, index) in content.content"  :key="index" :id="key">
            <pre v-highlight class="precontent" v-html="item"></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 分类内容
 *
 * @requires Type.vue
 * @author dongyang
 */
import CustomerLogo from '@/components/CustomerLogo'
import $ from 'jquery'
export default {
  name: 'TypeContent',
  props: {
    content: {
      type: Object
    }
  },
  data () {
    return {
      tabindex: 0,
      sedRouteTitle: {
        article: '文章',
        lives: '快讯',
        market: '行情',
        project: '项目库'
      },
      listData: [
        {
          name: '百度',
          logo: require('../assets/images/Image_logo_1.jpg'),
          url: 'https://www.baidu.com/'
        },
        {
          name: '搜狗',
          logo: require('../assets/images/Image_logo_2.jpg'),
          url: 'https://news.sogou.com/'
        },
        {
          name: '腾讯',
          logo: require('../assets/images/Image_logo_3.jpg'),
          url: 'https://www.qq.com/'
        },
        {
          name: '新浪',
          logo: require('../assets/images/Image_logo_4.jpg'),
          url: 'https://www.sina.com.cn/'
        },
        {
          name: '币看',
          logo: require('../assets/images/Image_logo_6.jpg'),
          url: 'https://bitkan.com/'
        },
        {
          name: '火币',
          logo: require('../assets/images/Image_logo_7.jpg'),
          url: 'https://www.huobi.com/'
        },
        {
          name: '库神钱包',
          logo: require('../assets/images/Image_logo_8.jpg'),
          url: 'https://www.coldlar.com/'
        },
        {
          name: 'AlCoin',
          logo: require('../assets/images/Image_logo_9.jpg'),
          url: 'https://www.aicoin.net.cn/'
        },
        {
          name: '金色财经',
          logo: require('../assets/images/Image_logo_11.jpg'),
          url: 'https://www.jinse.com/'
        },
        {
          name: 'conintime',
          logo: require('../assets/images/Image_logo_12.jpg'),
          url: 'http://www.cointime.com/'
        },
        {
          name: 'fx168',
          logo: require('../assets/images/Image_logo_13.jpg'),
          url: 'https://www.fx168.com/'
        },
        {
          name: '新浪财经',
          logo: require('../assets/images/Image_logo_14.jpg'),
          url: 'https://finance.sina.com.cn/'
        }
      ]
    }
  },
  methods: {
    linkM (e) {
      $('html, body').animate(
        {
          scrollTop: $('#' + e.target.className).offset().top - 73
        },
        {
          duration: 200, easing: 'swing'
        })
      return false
    },
    changeTab (index) {
      this.tabindex = index
    }
  },
  components: {
    'component-customer-logo': CustomerLogo
  },
  watch: {
    '$route': function () {
      this.tabindex = 0
    }
  }
}
</script>
<style lang="scss" scoped>
.leftfix {
  position: fixed;
  top: 73px;
}
.content {
  margin-top: 44px;
  .content__left {
    width: 170px;
    float: left;
    .left__title {
      background: rgba(59, 59, 67, 1);
      height: 60px;
      position: relative;
      p {
        position: absolute;
        top: 15px;
        left: 30px;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }
    }
    .left__main {
      background:rgba(255,255,255,1);
      a {
        display: block;
        padding: 10px 30px;
        cursor: pointer;
        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:400;
        color:rgba(33,33,42,1);
        line-height:30px;
        background:rgba(243,243,248,1);
        margin-bottom: 1px;
      }
      a:last-of-type {
        margin-bottom: 0;
      }
      a:hover {
        background:rgba(248,248,251,1);
      }
    }
  }
  .content__right {
    width: 800px;
    margin-left: 170px;
    position: relative;
    .hrsty {
      position: absolute;
      width: 100%;
      top: 59px;
      left: 0px;
      z-index: -1;
      border-bottom: 1px solid rgb(243, 243, 248);
    }
    .right__title {
      margin-left: 52px;
      span {
        margin: 0 25px;
        display: inline-block;
        padding: 16px 30px 12px;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(136, 136, 146, 1);
        line-height: 30px;
        cursor: pointer;
      }
      .active {
        color: rgba(33, 33, 42, 1);
        border-bottom: 3px solid rgba(59, 59, 67, 1);
      }
    }
    .right__main {
      width: 740px;
      margin-top: 40px;
      margin-left: 60px;
      .logolist {
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .logo {
          margin-right: 20px;
          margin-bottom: 30px;
        }
        .logo:nth-child(4n) {
          margin-right: 0;
        }
      }
      .apicontent {
        margin-left: 20px;
        .precontent {
          line-height: 30px;
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(33,33,42,1);
        }
      }
    }
  }
}
</style>
<style>
.precontent h3  {
    font-size:18px;
    font-weight:700;
    color:rgba(33,33,42,1);
    margin-block-start: 0;
    margin-block-end: 0;
    line-height: 30px;
}
.precontent h4 {
    font-weight:500;
    margin-block-start: 0;
    margin-block-end: 0;
    line-height: 30px;
}
.precontent span {
  line-height: 20px;
}
</style>
